import { render, staticRenderFns } from "./WalletHolidayWarning.vue?vue&type=template&id=61ac8122&"
import script from "./WalletHolidayWarning.vue?vue&type=script&lang=js&"
export * from "./WalletHolidayWarning.vue?vue&type=script&lang=js&"
import style0 from "./WalletHolidayWarning.vue?vue&type=style&index=0&id=61ac8122&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports